import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Conocer el tema",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me está pidiendo esto hoy?",
      "¿Dónde se asienta esto en mí ahora?",
      "¿Qué se siente demasiado tierno para decir en voz alta?"
    ],
      [
      "¿Qué me está pidiendo esto hoy?",
      "¿Dónde se asienta esto en mí ahora?",
      "¿Qué se siente demasiado tierno para decir en voz alta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer disparador",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es el primer disparador que puedo nombrar?",
      "¿Qué siento en el primer segundo?",
      "¿Qué necesitaba en ese momento?"
    ],
      [
      "¿Cuál es el primer disparador que puedo nombrar?",
      "¿Qué siento en el primer segundo?",
      "¿Qué necesitaba en ese momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Lo que pasa en el cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde en mi cuerpo siento esto ahora?",
      "¿Cómo es mi respiración cuando esto aparece?",
      "¿Qué intenta decirme mi cuerpo?"
    ],
      [
      "¿Dónde en mi cuerpo siento esto ahora?",
      "¿Cómo es mi respiración cuando esto aparece?",
      "¿Qué intenta decirme mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La historia que me cuento",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pensamiento aparece de inmediato?",
      "¿Qué historia me cuento sobre esto?",
      "¿Qué posibilidad más suave existe?"
    ],
      [
      "¿Qué pensamiento aparece de inmediato?",
      "¿Qué historia me cuento sobre esto?",
      "¿Qué posibilidad más suave existe?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "La necesidad debajo",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es la necesidad debajo?",
      "¿Cómo intento cubrirla ahora?",
      "¿Cómo me gustaría pedirla con suavidad?"
    ],
      [
      "¿Cuál es la necesidad debajo?",
      "¿Cómo intento cubrirla ahora?",
      "¿Cómo me gustaría pedirla con suavidad?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Un límite interno pequeño",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pequeño límite me protegería hoy?",
      "¿Dónde cruzo mi propio límite?",
      "¿Cómo sonaría una frase de límite interno?"
    ],
      [
      "¿Qué pequeño límite me protegería hoy?",
      "¿Dónde cruzo mi propio límite?",
      "¿Cómo sonaría una frase de límite interno?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Una pausa en medio",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es la primera señal de que el bucle empieza?",
      "¿Qué pequeña pausa es posible para mí?",
      "¿Qué temo que pase si me detengo?"
    ],
      [
      "¿Cuál es la primera señal de que el bucle empieza?",
      "¿Qué pequeña pausa es posible para mí?",
      "¿Qué temo que pase si me detengo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Suavidad hacia mí",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué palabra suave puedo decirme?",
      "¿Qué le diría a un/a amigo/a en mi lugar?",
      "¿Qué cambia en mí cuando lo escucho?"
    ],
      [
      "¿Qué palabra suave puedo decirme?",
      "¿Qué le diría a un/a amigo/a en mi lugar?",
      "¿Qué cambia en mí cuando lo escucho?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "El miedo debajo",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué miedo hay debajo?",
      "¿Cómo me protejo de él?",
      "¿Qué necesito para sentirme un poco más seguro/a?"
    ],
      [
      "¿Qué miedo hay debajo?",
      "¿Cómo me protejo de él?",
      "¿Qué necesito para sentirme un poco más seguro/a?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Responsabilidad suave",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es mi parte sin culparme?",
      "¿Qué no me corresponde cargar?",
      "¿Qué pequeña elección está bajo mi control?"
    ],
      [
      "¿Cuál es mi parte sin culparme?",
      "¿Qué no me corresponde cargar?",
      "¿Qué pequeña elección está bajo mi control?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Una nueva frase pequeña",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué frase suelo decirme?",
      "¿Cómo sonaría una frase más suave?",
      "¿Cómo quiero sentirme después de la próxima vez?"
    ],
      [
      "¿Qué frase suelo decirme?",
      "¿Cómo sonaría una frase más suave?",
      "¿Cómo quiero sentirme después de la próxima vez?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Elegir conexión",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es una pequeña elección de conexión para mí?",
      "¿Qué me dificulta elegirla?",
      "¿Qué pequeño movimiento puedo hacer hoy?"
    ],
      [
      "¿Cuál es una pequeña elección de conexión para mí?",
      "¿Qué me dificulta elegirla?",
      "¿Qué pequeño movimiento puedo hacer hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Una pequeña dirección hacia adelante",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Hacia dónde quiero que vaya la dirección?",
      "¿Qué pequeño valor me importa aquí?",
      "¿Qué pequeño hábito podría ayudar?"
    ],
      [
      "¿Hacia dónde quiero que vaya la dirección?",
      "¿Qué pequeño valor me importa aquí?",
      "¿Qué pequeño hábito podría ayudar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Dejo que lo que surgió esté aquí."
    ],
      [
      "Dejo que lo que surgió esté aquí."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave",
    opening: localizedGenderNode(
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ],
      [
      "Hoy me quedo conmigo alrededor de este tema.",
      "No resuelvo.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre mí en este camino?",
      "¿Qué frase de regreso usaré en momentos difíciles?",
      "¿Cómo quiero recordar esta respiración?"
    ],
      [
      "¿Qué aprendí sobre mí en este camino?",
      "¿Qué frase de regreso usaré en momentos difíciles?",
      "¿Cómo quiero recordar esta respiración?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Elijo presencia antes de reaccionar."
    ],
      [
      "Elijo presencia antes de reaccionar."
    ]
    ),
    action: localizedGenderNode(
      "una respiración.",
      "una respiración."
    ),
  },
].map(buildNormalizedDay);

export const difficultySettingBoundariesWithTheChildrenBlueprintEs = buildNormalizedPilotBlueprint({
  id: "difficulty_setting_boundaries_with_the_children_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "difficulty_setting_boundaries_with_the_children",
  category: "parenting_children",
  journeyName: {
    he: "קושי להציב גבולות עם הילדים",
    en: "Difficulty setting boundaries with the children",
    es: "Dificultad para establecer límites con los niños. — 18 ימים",
  },
  days,
});

export default difficultySettingBoundariesWithTheChildrenBlueprintEs;
